import { MunicipioCorporativo } from "../corporativo/endereco-corporativo";
import { EsferaAvaliacaoSgsia, EsferasAvaliacaoSgsiaEnum } from './esfera-avaliacao-sgsia';

export class ControleAcessoSgsia {
    idControleAcesso: number;
    cdPerfil: string;
    nmFiscal: string;
    tipoDocumento: number;
    nrDocumento: string;
    nrTelefone: string;
    email: string;
    nmInstituicao: string;
    cnpj: string;
    numSolicitacao?: string;
    uf: string;
    cargoFuncao: string;
    nrSolicitacao: string;
    dataSolicitacao: string | Date;
    dataAprovacaoSolicitacao: string | Date;
    situacao: string;
    ativo: string;
    justificativaGestor: string;
    esferaAvaliacao?: EsferasAvaliacaoSgsiaEnum;
    idMunicipio?:number;
    municipio?:MunicipioCorporativo;
    idServicoInspecao?: number;
    // arquivosSolicitacao: string;

    get nmSituacao() {
        return this.capitalize(this.situacao);
    }

    get nmEsferaAvaliacao(): string {
        return EsferaAvaliacaoSgsia.descricaoEsferaAvaliacao(this.esferaAvaliacao);
    }

    capitalize = (s) => {
        if (typeof s !== 'string') {
            return '';
        }
        return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    }

    /**
     * Converte um objeto json em instancias da classe
     */
    static fromJson(jsonData: any): ControleAcessoSgsia {
        return Object.assign(new ControleAcessoSgsia(), jsonData);
    }
}
